// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f98e7f0b","513":"fb11e56f","703":"5cb73fe0"}[chunkId] + ".chunk.js";
};